<template>
	<div id="page">



		<div class="page-content">

			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					تغییر رمز عبور
					<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
				</h2>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style">
				<div class="content mt-2 mb-0">
					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">رمز عبور فعلی</span>
						<input type="password" v-model="oldPassword" @blur="v$.oldPassword.$touch()" :class="{invalid:v$.oldPassword.$error}">
						<p class="text-danger" v-if="v$.oldPassword.required.$invalid && v$.oldPassword.$dirty">لطفا رمز عبور فعلی را وارد کنید</p>
					</div>

					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">رمز عبور جدید</span>
						<input type="password" v-model="password" @blur="v$.password.$touch()" :class="{invalid:v$.password.$error}">
						<p class="text-danger" v-if="v$.password.required.$invalid && v$.password.$dirty">لطفا رمز عبور جدید را وارد کنید</p>
						<p class="text-danger" v-if="v$.password.minLength.$invalid && v$.password.$dirty">رمز عبور می بایست حداقل ۶ کاراکتر باشد.</p>

					</div>

					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">تکرار رمز عبور </span>
						<input type="password" v-model="confirmPassword" @blur="v$.confirmPassword.$touch()" :class="{invalid:v$.confirmPassword.$error}">
						<p class="text-danger" v-if="v$.confirmPassword.required.$invalid && v$.confirmPassword.$dirty">لطفا تکرار رمز عبور را وارد کنید</p>
						<p class="text-danger" v-if="v$.confirmPassword.sameAsPasswordRef.$invalid && v$.confirmPassword.$dirty">رمز عبور جدید و تکرار آن باهم مطابقت ندارند.</p>

					</div>



					<button :disabled="v$.$invalid || Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="ChangePass">ثبت</button>

				</div>

			</div>




		</div>
		<!-- end of page content-->



		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
		<Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList" v-if="isKarnegasht==true"></Help-Menu>

	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core';
    import HelpMenu from '../Components/HelpMenu.vue';
	import {
        required, sameAs, minLength
	} from '@vuelidate/validators';

	export default {
        components: {
            "Help-Menu": HelpMenu
        },
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				password: "",
				confirmPassword:"",
				oldPassword: "",
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			}
		},
		methods: {
			ChangePass() {

				const login = {
                    oldPassword: this.oldPassword,
					password: this.password,
					confirmPassword: this.confirmPassword
				};

				this.$store.dispatch("ChangePass", login);
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {

			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		validations() {
			return {
			oldPassword: {
				required
			},
            password: {
				required,
                minLength: minLength(6)
            },
			confirmPassword: {
                required,
                sameAsPasswordRef: sameAs(this.password),
            }

			}
		}
	};
</script>


<style>
	.invalid {
		border: 1px solid red !important;
		box-shadow: 0 0 5px red !important;
	}
</style>

